export enum RouteName {
  List = 'secure-authentications-list',
}
